export const healthFr = {
  title: "Santé du système",
  integrations: "Intégrations",
  jobs: "Tâches planifiées",
  pending_actions: "Actions automatisées en attente",
  failed_runs: "Exécutions en échec (7 jours)",
  sync_now: "Synchroniser maintenant",
  syncing: "Synchronisation en cours…",
  sync_done: "Synchronisation lancée.",
  sync_failed: "La synchronisation a échoué.",
  sync_forbidden: "Accès refusé : réservé aux administrateurs.",
  sync_server_error: "La synchronisation a échoué (code : %{code}).",
  storage_purge: "Suppressions de fichiers en échec",
  late: "En retard",
  ok: "OK",
  error: "Erreur",
  never: "Jamais",
  never_run: "Jamais exécuté",
  none: "Rien à signaler",
  // GAVION full-email: the content queue on the gavion-graph-sync:content row
  content_backlog:
    "%{smart_count} courriel en attente — le plus ancien depuis %{minutes} min |||| %{smart_count} courriels en attente — le plus ancien depuis %{minutes} min",
  statuses: {
    late: "En retard",
    failing: "En échec",
    ok: "OK",
    connected: "Connecté",
    error: "Erreur",
    disconnected: "Déconnecté",
    needs_reauth: "Reconnexion requise",
  },
  skipped: {
    ai_not_configured: "Clé IA absente : aucun brouillon rédigé",
  },
  codes: {
    network: "Réseau indisponible",
    timeout: "Délai dépassé",
    unknown: "Erreur inconnue",
    forbidden: "Accès refusé",
    http: "Erreur HTTP %{status}",
    db: "Erreur de base de données (%{code})",
    invalid_credentials: "Identifiants VoIP.ms invalides",
    ip_not_enabled: "IP non autorisée chez VoIP.ms",
    purge_failed: "Des fichiers n'ont pas pu être supprimés",
    retention_failed: "La tâche de conservation a échoué",
    job_run_write_failed: "Impossible d'enregistrer l'exécution de la tâche",
  },
  columns: {
    bucket: "Compartiment",
    source: "Origine",
    name: "Nom",
    status: "Statut",
    last_run: "Dernière exécution",
    last_success: "Dernier succès",
    last_error: "Dernière erreur",
    failures: "Échecs consécutifs",
    due: "Échéance",
    type: "Type",
    attempts: "Tentatives",
    rule: "Règle",
    date: "Date",
  },
};
